import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "icb-badge"
}
const _hoisted_3 = {
  key: 1,
  class: "icb-example"
}

import { computed } from 'vue'
import { restoreInternalChatPopup, useInternalChatPopup } from '@/composables/useInternalChatPopup'
import { useAgentChatCp } from '@/composables/useAgentChatCp'
import { useLinkus } from '@/composables/useLinkus'


export default /*@__PURE__*/_defineComponent({
  __name: 'InternalChatBubble',
  props: {
    sidebarOpen: { type: Boolean }
  },
  setup(__props: any) {

// Conversas minimizado (InternalChatPopup): clique volta o popup no mesmo lugar e tamanho; o × pequeno fecha.
// Fica acima do telefone do navegador (PhoneWidget), que ocupa o mesmo canto quando o Linkus está ligado.
const props = __props

const { state, exampleMode } = useInternalChatPopup()
const { totalUnread } = useAgentChatCp()
const { availability } = useLinkus()

const left = computed(() => (props.sidebarOpen ? 220 : 64) + 16)
const bottom = computed(() => (availability.value?.available ? 16 + 64 : 16))
const unread = computed(() => (exampleMode.value ? 2 : totalUnread.value))
const title = computed(() => `Conversas${unread.value ? ` (${unread.value} não lidas)` : ''} — clique pra abrir`)

return (_ctx: any,_cache: any) => {
  return (_unref(state) === 'minimized')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "icb",
        style: _normalizeStyle({ left: `${left.value}px`, bottom: `${bottom.value}px` })
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "icb-btn",
          title: title.value,
          "aria-label": title.value,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(restoreInternalChatPopup) && _unref(restoreInternalChatPopup)(...args)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
          ], -1)),
          (unread.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(unread.value > 99 ? '99+' : unread.value), 1))
            : _createCommentVNode("", true),
          (_unref(exampleMode))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "exemplo"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1),
        _createElementVNode("button", {
          type: "button",
          class: "icb-close",
          title: "Fechar Conversas",
          "aria-label": "Fechar Conversas",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (state.value = 'closed'))
        }, "×")
      ], 4))
    : _createCommentVNode("", true)
}
}

})